import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../context/CartContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiMinus, FiPlus, FiTrash2, FiShoppingBag } = FiIcons;

export default function CartDrawer() {
  const { cart, isCartOpen, setIsCartOpen, removeFromCart, updateQuantity, cartTotal } = useCart();

  return (
    <AnimatePresence>
      {isCartOpen && (
        <>
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsCartOpen(false)}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100]"
          />
          <motion.div 
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed right-0 top-0 h-full w-full max-w-md bg-[#faf9f6] z-[101] shadow-2xl flex flex-col"
          >
            <div className="p-6 border-b border-zinc-200 flex justify-between items-center bg-white">
              <h2 className="text-xl font-black uppercase tracking-tighter">Your Workspace</h2>
              <button onClick={() => setIsCartOpen(false)} className="p-2 hover:bg-zinc-100 rounded-full transition-colors">
                <SafeIcon icon={FiX} className="text-2xl" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              {cart.length === 0 ? (
                <div className="h-full flex flex-col items-center justify-center text-center opacity-50">
                  <SafeIcon icon={FiShoppingBag} className="text-6xl mb-4" />
                  <p className="font-bold uppercase tracking-widest text-sm">Your cart is empty</p>
                  <button 
                    onClick={() => setIsCartOpen(false)}
                    className="mt-4 text-red-600 font-bold border-b-2 border-red-600"
                  >
                    CONTINUE SHOPPING
                  </button>
                </div>
              ) : (
                <div className="space-y-6">
                  {cart.map((item) => (
                    <div key={item.id} className="flex gap-4 group">
                      <div className="w-24 h-24 bg-zinc-100 shrink-0 overflow-hidden">
                        <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                      </div>
                      <div className="flex-1">
                        <div className="flex justify-between mb-1">
                          <h3 className="font-bold text-sm uppercase tracking-tight">{item.name}</h3>
                          <button onClick={() => removeFromCart(item.id)} className="text-zinc-400 hover:text-red-600 transition-colors">
                            <SafeIcon icon={FiTrash2} />
                          </button>
                        </div>
                        <p className="text-zinc-500 text-sm mb-4 font-bold">${item.price}</p>
                        <div className="flex items-center gap-4">
                          <div className="flex items-center border border-zinc-200">
                            <button onClick={() => updateQuantity(item.id, -1)} className="p-2 hover:bg-zinc-100"><SafeIcon icon={FiMinus} /></button>
                            <span className="w-8 text-center font-bold text-sm">{item.quantity}</span>
                            <button onClick={() => updateQuantity(item.id, 1)} className="p-2 hover:bg-zinc-100"><SafeIcon icon={FiPlus} /></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {cart.length > 0 && (
              <div className="p-8 border-t border-zinc-200 bg-white">
                <div className="flex justify-between items-center mb-6">
                  <span className="font-bold uppercase tracking-widest text-xs text-zinc-500">Subtotal</span>
                  <span className="text-2xl font-black tracking-tighter">${cartTotal.toFixed(2)}</span>
                </div>
                <button className="w-full btn-primary py-5 text-sm tracking-[0.2em]">
                  PROCEED TO CHECKOUT
                </button>
                <p className="text-center text-[10px] text-zinc-400 mt-4 font-bold uppercase tracking-widest">
                  Shipping and taxes calculated at checkout
                </p>
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}